/**
 * @generated SignedSource<<c6365d0589efa6565da074733388f18b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RepositoryBuildListSubscription$variables = {
  branch?: string | null;
  repositoryID: string;
};
export type RepositoryBuildListSubscription$data = {
  readonly repository: {
    readonly " $fragmentSpreads": FragmentRefs<"RepositoryBuildList_repository">;
  } | null;
};
export type RepositoryBuildListSubscription = {
  response: RepositoryBuildListSubscription$data;
  variables: RepositoryBuildListSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "branch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repositoryID"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "repositoryID"
  }
],
v3 = {
  "kind": "Variable",
  "name": "branch",
  "variableName": "branch"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owner",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RepositoryBuildListSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "RepositoryBuildList_repository"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RepositoryBuildListSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platform",
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerPermission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "masterBranch",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "last",
                "value": 50
              }
            ],
            "concreteType": "RepositoryBuildsConnection",
            "kind": "LinkedField",
            "name": "builds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RepositoryBuildEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Build",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clockDurationInSeconds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "changeMessageTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Repository",
                        "kind": "LinkedField",
                        "name": "repository",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "buildCreatedTimestamp",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "changeIdInRepo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPausedTasks",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "branch",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tag",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b18d38dd873d88bff06a195d45390ec2",
    "id": null,
    "metadata": {},
    "name": "RepositoryBuildListSubscription",
    "operationKind": "subscription",
    "text": "subscription RepositoryBuildListSubscription(\n  $repositoryID: ID!\n  $branch: String\n) {\n  repository(id: $repositoryID) {\n    ...RepositoryBuildList_repository_SmLDq\n    id\n  }\n}\n\nfragment BuildBranchNameChipNew_build on Build {\n  id\n  branch\n  tag\n  repository {\n    id\n    owner\n    name\n  }\n}\n\nfragment BuildCard_build on Build {\n  id\n  changeMessageTitle\n  repository {\n    ...RepositoryNameChipNew_repository\n    ...RepositoryOwnerChipNew_repository\n    id\n  }\n  ...CreatedTime_build\n  ...Hash_build\n  ...Duration_build\n  ...BuildStatusChipNew_build\n  ...BuildBranchNameChipNew_build\n}\n\nfragment BuildStatusChipNew_build on Build {\n  id\n  status\n  hasPausedTasks\n}\n\nfragment CreateBuildDialog_repository on Repository {\n  id\n  owner\n  name\n  masterBranch\n}\n\nfragment CreatedTime_build on Build {\n  buildCreatedTimestamp\n}\n\nfragment Duration_build on Build {\n  clockDurationInSeconds\n}\n\nfragment Hash_build on Build {\n  changeIdInRepo\n}\n\nfragment RepositoryBuildList_repository_SmLDq on Repository {\n  id\n  platform\n  owner\n  name\n  viewerPermission\n  ...CreateBuildDialog_repository\n  builds(last: 50, branch: $branch) {\n    edges {\n      node {\n        id\n        clockDurationInSeconds\n        status\n        ...BuildCard_build\n      }\n    }\n  }\n}\n\nfragment RepositoryNameChipNew_repository on Repository {\n  owner\n  name\n}\n\nfragment RepositoryOwnerChipNew_repository on Repository {\n  owner\n}\n"
  }
};
})();

(node as any).hash = "c79ba3a756bded384953d43e69717829";

export default node;
